import React,{lazy} from 'react'
import { Route } from 'react-router-dom';
const Verify = lazy(()=> import('../Pages/Verify/Verify.jsx'));
const Main = lazy(() => import('../Dashboard/Main.jsx'));
const ListOfCourses = lazy(() => import('../Dashboard/ListOfCourses/ListOfCourses.jsx'));
const MySchedule = lazy(() => import('../Dashboard/MySchedule/MySchedule.jsx'));
const AddNewCourses = lazy(() => import('../Dashboard/AddNewCourses/AddNewCourses.jsx'));
const Profile = lazy(()=>import('../Dashboard/Profile/Profile.jsx'))

const ExpertRoutes = (
    <>
        <Route path='/dashboard' element={<Main />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/listofjobs' element={<ListOfCourses />} />
        <Route path='/addnewjobs'  element={<AddNewCourses />} />
        <Route path='/addnewjobs/:id' element={<AddNewCourses />} />
        <Route path='/schedules' element={<MySchedule />} />
        <Route path='/verify' element={<Verify />} />


    </>
)

export default ExpertRoutes